import React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";

const navigationTabsStyle = (theme, clientColor, tabCount) => ({
  tabs: {
    "& .MuiTab-root": {
      backgroundColor: grayColor[13],
      opacity: 0.7,
      color: grayColor[2],
      flex: `1 1 ${100 / tabCount}%`,
      minWidth: `${100 / tabCount}%`,
      "&.Mui-selected": {
        backgroundColor: "white",
        color: clientColor,
        opacity: 1,
      },
      "&.Mui-disabled": {
        backgroundColor: grayColor[13],
        color: grayColor[3],
        cursor: "not-allowed",
        opacity: 0.5,
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: clientColor,
    },
  },
});

export default function NavigationTabs({ value, onChange, options, color }) {
  const useStyles = makeStyles((theme) =>
    navigationTabsStyle(theme, color, options.length),
  );
  const classes = useStyles();

  return (
    <Tabs
      value={value}
      onChange={(e, newValue) => onChange(newValue)}
      variant="fullWidth"
      className={classes.tabs}
    >
      {options.map((opt) => {
        const tab = (
          <Tab
            key={opt.value}
            value={opt.value}
            label={opt.label}
            disabled={opt.disabled}
          />
        );

        return opt.disabled && opt.tooltip ? (
          <Tooltip key={opt.value} title={opt.tooltip} placement="top">
            <span
              style={{
                display: "inline-block",
                width: "100%",
                textAlign: "center",
              }}
            >
              {tab}
            </span>
          </Tooltip>
        ) : (
          tab
        );
      })}
    </Tabs>
  );
}

NavigationTabs.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      tooltip: PropTypes.string,
    }),
  ).isRequired,
  color: PropTypes.string.isRequired,
};
